import * as fromDatatype from '../datatype-library/index';

export interface app_perm_assignee_target_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_type: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_table: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_line_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_line_table: fromDatatype.VarcharDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.VarcharDatatypeInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_policy: fromDatatype.JsonDatatypeInterface;
  target_filter: fromDatatype.JsonDatatypeInterface;
  tenant_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  applet_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  perm_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  perm_set_line_guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_code: fromDatatype.VarcharDatatypeInterface;
}

export class app_perm_assignee_target_link_RowClass implements app_perm_assignee_target_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_type: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_table: fromDatatype.VarcharDatatypeInterface;
  assignee_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_line_guid: fromDatatype.VarcharDatatypeInterface;
  assignee_line_table: fromDatatype.VarcharDatatypeInterface;
  target_type: fromDatatype.VarcharDatatypeInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.VarcharDatatypeInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_policy: fromDatatype.JsonDatatypeInterface;
  target_filter: fromDatatype.JsonDatatypeInterface;
  tenant_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  applet_hdr_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  perm_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  perm_set_line_guid: fromDatatype.GuidDataFieldInterface;
  perm_dfn_code: fromDatatype.VarcharDatatypeInterface;
}
